<template>
  
</template><template>
  <a-modal v-model="visible" :title="$t('API headers')" :width="800">
    <div slot="footer">
      <a-button type="default" @click="() => visible = false">{{ $t('取消') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
    <a-form-model ref="form" layout="inline" style="margin-top: 20px;">
      <div v-for="(header, index) in headers" :key="index" style="display: flex; flex-direction: row;">
        <a-form-model-item :label="$t('Key')" style="width: 100%">
          <a-input v-model="header.key" style="width: 100%;" />
        </a-form-model-item>
        <a-form-model-item :label="$t('Value')" style="width: 100%">
          <a-input v-model="header.value" style="width: 100%;" />
        </a-form-model-item>
        <a-button type="link" @click="handleDelete(index)" style="flex-shrink: 0; width: 60px;">{{ $t('删除') }}</a-button>
      </div>
    </a-form-model>
  </a-modal>
</template>
<script>

export default {
  data() {
    return {
      visible: false,
      loading: false,
      pageData: {},
      headers: []
    }
  },
  computed: {
    
  },
  methods: {
    show(page) {
      this.pageData = { ...page }
      this.headers = []
      this.resetHeaders()
      this.visible = true
    },
    resetHeaders() {
      const data = this.$store.getters.getHeaders(this.pageData.id)
      if (!data) {
        return
      }
      const keys = Object.keys(data)
      const headers = []
      keys.forEach(k => {
        headers.push({ key: k, value: data[k] })
      })
      this.headers = headers
    },
    handleAdd() {
      this.headers.push({ key: null, value: null })
    },
    handleDelete(index) {
      this.headers.splice(index, 1)
    },
    handleCommit() {
      const commitData = {}
      this.headers.forEach(header => {
        if (!(header.key?.length)) {
          return
        }
        commitData[header.key] = header.value
      })
      this.$store.dispatch('setHeaders', { key: this.pageData.id, value: commitData })
      this.visible = false
    }
  }
}
</script>